"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.tabs.threads': 'Hilos',
    'whatsapp.tabs.settings': 'Configuración',
    'whatsapp.tabs.groups': 'Grupos',
    'whatsapp.tabs.directMessages': 'Mensajes directos',
    'whatsapp.tabs.email': 'Correo electrónico',
    'whatsapp.tabs.emailSettings': 'Configuración de correo',
};
